import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

import { BlockPreviewRequest } from '../modals/content/block-preview/block-preview-request';

/** What the server answers: the whole preview document, and its notes ("Hidden on Randwick: no venue within 15 km"). */
export interface BlockPreviewResult {
  html: string;
  notes: string[];
}

/**
 * The block preview's one request (#263): the editor's unsaved blocks to conductor-server, which projects them as the
 * External API does and has picaluna-v3's preview Worker draw them. HTTP only; the panel's logic is
 * BlockPreviewController (modals/content/block-preview/).
 */
@Injectable({ providedIn: 'root' })
export class BlockPreviewService {
  constructor(private http: HttpClient) {}

  render(request: BlockPreviewRequest): Observable<BlockPreviewResult> {
    return this.http
      .post<{
        data: BlockPreviewResult;
      }>(environment.api.host + environment.api.paths.api.blockPreview, request)
      .pipe(map((r) => r.data));
  }
}
